import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("innus-cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("innus-cart", JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) {
        return prev.map((i) =>
          i.product_id === product.id ? { ...i, qty: i.qty + qty } : i
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          price: product.price,
          unit: product.unit,
          image: product.image,
          qty,
        },
      ];
    });
    setOpen(true);
  };

  const setQty = (id, qty) => {
    if (qty <= 0) {
      setItems((prev) => prev.filter((i) => i.product_id !== id));
    } else {
      setItems((prev) =>
        prev.map((i) => (i.product_id === id ? { ...i, qty } : i))
      );
    }
  };

  const remove = (id) =>
    setItems((prev) => prev.filter((i) => i.product_id !== id));

  const clear = () => setItems([]);

  const total = useMemo(
    () => items.reduce((s, i) => s + i.price * i.qty, 0),
    [items]
  );
  const count = useMemo(() => items.reduce((s, i) => s + i.qty, 0), [items]);

  return (
    <CartContext.Provider
      value={{ items, add, setQty, remove, clear, total, count, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);

export const inr = (n) => "₹" + Number(n).toLocaleString("en-IN");
